const blog = [
  {
    id: 10,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 3.5, count: 354 },
  },
  {
    id: 11,
    title: "How to write article",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "World" },
    ratings: { value: 4.5, count: 154 },
  },
  {
    id: 7,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/01/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "technology" },
    ratings: { value: 3.5, count: 354 },
  },
  {
    id: 8,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "18/10/2018",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "website" },
    ratings: { value: 2.5, count: 354 },
  },
  {
    id: 6,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Others/images/14.jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "design" },
    ratings: { value: 4.0, count: 354 },
  },
  {
    id: 1,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 1.5, count: 14 },
  },
  {
    id: 2,
    title: "How to write article",
    imageUrl: "https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 0.5, count: 304 },
  },
  {
    id: 3,
    title: "How to create blog",
    imageUrl:
      "https://mdbootstrap.com/img/Photos/Horizontal/Food/full page/2.jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 3.5, count: 354 },
  },
  {
    id: 4,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}, {}],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 3.5, count: 354 },
  },
  {
    id: 5,
    title: "How to create blog",
    imageUrl: "https://mdbootstrap.com/img/Photos/Others/images/14.jpg",
    author: "Ashwanee Kumar Gupta",
    createdDate: "20/10/2020",
    tags: ["Travel", "World"],
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    comments: [{ id: 1 }],
    likes: [{}],
    views: 0,
    category: { id: 1, name: "travel" },
    ratings: { value: 3.5, count: 354 },
  },
];

const category = [
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
  { id: 1, name: "Travel", count: 5 },
];

const getBlog = () => {
  return blog;
};
const getBlogCategory = () => {
  return category;
};
const getBlogData = (blogId) => {
  return blog.find((blog) => blog.id === blogId);
};

export default {
  getBlog,
  getBlogData,
  getBlogCategory,
};
